<template>
  <!-- Área principal do Workspace -->
  <div class="p-6">
    <!-- Header com logo -->
    <div class="mb-6 flex justify-start">
      <img 
        :src="logoTextImage" 
        :alt="t('workspacePage.logoAlt')" 
        class="h-8 object-contain"
      />
    </div>

    <!-- Conteúdo do workspace -->
    <div class="card">
      <h1 class="text-2xl font-bold" style="color: var(--text-primary)">
        {{ t('workspacePage.title', { id: $route.params.id }) }}
      </h1>
      <p class="mt-2" style="color: var(--text-secondary)">
        {{ t('workspacePage.placeholder') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'
import logoTextImage from '../assets/logo_l_w.png'

const { t } = useI18n()
const authStore = useAuthStore()

onMounted(async () => {
  if (!authStore.isAuthenticated) {
    return
  }
  
  // Carregar dados do usuário se necessário
  if (!authStore.user) {
    try {
      await authStore.fetchUser()
    } catch (error) {
      console.error('Erro ao carregar usuário:', error)
    }
  }
})
</script>